import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { Button } from 'src/components';

import { APP_LANGUAGES, BREADCRUMBS_DATA } from 'src/constants';

import {
  ArrowRightBottomIcon,
  BackgroundImage,
  CoinsImage,
  DollarLetterImage,
  EllipseImage,
} from 'src/assets';
import './withdrawalSuccess.scss';

export const WithdrawalSuccess = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const params = useParams();

  const language = params?.language;

  useEffect(() => {
    if (language) {
      const findedLanguage = APP_LANGUAGES.find((item) => item === language) || 'en';

      i18n.changeLanguage(findedLanguage);
    }
  }, [i18n, language]);

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.WITHDRAWAL));
  }, [dispatch]);

  return (
    <div className="withdrawal-success">
      <div className="withdrawal-success-content">
        <div>
          <div className="withdrawal-success-title">
            <h1>
              <blue-text>{t('withdrawal:funds')}</blue-text> {t('withdrawal:withdrawal')}
            </h1>
            <div className="withdrawal-success-subtitle">{t('withdrawal:subtitle')}</div>
          </div>

          <div className="withdrawal-success-form">
            <div className="withdrawal-success-form-button">
              <Button title={t('title:continue')} icon={ArrowRightBottomIcon} />
            </div>
          </div>
        </div>

        <div className="withdrawal-success-images-container">
          <div className="withdrawal-success-images-wrapper">
            <img
              src={BackgroundImage}
              alt={BackgroundImage}
              className="withdrawal-success-images-background image"
            />
            <img
              src={DollarLetterImage}
              alt={DollarLetterImage}
              className="withdrawal-success-images-check image"
            />
            <img
              src={CoinsImage}
              alt={CoinsImage}
              className="withdrawal-success-images-stars image"
            />
            <img
              src={EllipseImage}
              alt={EllipseImage}
              className="withdrawal-success-images-ellipse1 image"
            />
            <img
              src={EllipseImage}
              alt={EllipseImage}
              className="withdrawal-success-images-ellipse2 image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
